import {
  Button,
  Chip,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import ButtonCustom from "../../../components/ButtonCustom";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useGetUserId from "../../../hooks/users/useGetUserId";
import useCreateUser from "../../../hooks/users/useCreateUser";
import { IUser } from "../../../service/user/interfaces/IUser";
import { Face, Visibility, VisibilityOff } from "@mui/icons-material";
import useUpdateUser from "../../../hooks/users/useUpdateUser";
import useGetUserProfilesTPClient from "../../../hooks/users/useGetUserProfilesTPClient";
import AutoCompleteCustom from "../../../components/AutoCompleteCustom";
import { MuiTelInput } from "mui-tel-input";
import { useNotificationSnackbar } from "../../../hooks/useNotificationSnackbar";


function UserRegisterPage() {
  const navigate = useNavigate();
  const params = useParams();
  const { data, isLoading } = useGetUserId(params?.publicId || "");
  const [profiles] = useGetUserProfilesTPClient();
  const { createUserHooks } = useCreateUser();
  const { updateUserHooks } = useUpdateUser();
  const { onErrorSnackbar } = useNotificationSnackbar();
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [title, setTitle] = useState("");
  const [buttonText, setButtonText] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const loginUser = localStorage.getItem('Login');
  const [form, setForm] = useState<IUser | any>({
    idUsuario: 0,
    nome: "",
    perfil: "",
    tipo: "",
    contato: false,
    telefone: "",
    email: "",
    senha: "",
    ativo: true,
  });
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    if (params.publicId) {
      setTitle("Editar Utilizador");
      setButtonText("Editar");
      setForm(data);
    } else {
      setTitle("Adicionar Utilizador");
      setButtonText("Cadastrar");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading]);

  useEffect(() => {
    if (form) {
      const allowedNullFields = ["createdAt", "createdBy", "editedBy", "editedAt"];
      const isComplete = Object.entries(form).every(([key, value]) => {
        if (allowedNullFields.includes(key)) {
          return true; // ignora esses campos
        }
        return value !== null && String(value).trim() !== "";
      });
      
      setIsFormComplete(isComplete);
      
    }
  }, [form]);

  const handleSubmit = () => {
    if (params.publicId) {
      form.editedBy = loginUser
      form.editedAt = new Date()
      updateUserHooks(form).then((resp) => {
          if(resp.status === 200) {
            navigate("/user-list");
          }
          else {
            onErrorSnackbar(resp.data)
          }
          })
    } else {
      form.createdBy = loginUser
      form.createdAt = new Date()

      createUserHooks(form).then((resp: any) => {
          if(resp.status === 200) {
            navigate("/user-list");
          }
          else {
            onErrorSnackbar(resp.data)
          }
      })
    }
  };
  const handleChange = (campo: any) => (event: any) => {
    if (campo === "ativo" || campo === "contato") {
      setForm({
        ...form,
        [campo]: event.target.value === "true" ? true : false,
      });
    } else if (campo === "perfil") {
      setForm({ ...form, [campo]: event, tipo: event });
    } else if (campo === "telefone") {
      setForm({ ...form, [campo]: event?.replace(/\s+/g, "") });
    } else {
      setForm({ ...form, [campo]: event.target.value });
    }
  };
  return (
    <Grid container spacing={2}>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Chip icon={<Face color="warning" />} label={title} />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <TextField
          type="text"
          label="Nome"
          variant="filled"
          fullWidth
          value={form?.nome ?? ""}
          onChange={handleChange("nome")}
        />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <AutoCompleteCustom
          title="Perfil"
          options={profiles}
          variant="filled"
          value={form?.perfil ?? ""}
          field="label"
          fieldId="idBRAN"
          onChange={handleChange("perfil")}
        />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <TextField
          type="text"
          label="Titulo"
          variant="filled"
          fullWidth
          value={form?.titulo ?? ""}
          onChange={handleChange("titulo")}
        />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <FormControl fullWidth variant="filled">
          <InputLabel id="demo-simple-select-label">Contato</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={form?.contato ?? ""}
            label="Contato"
            fullWidth
            onChange={handleChange("contato")}
          >
            <MenuItem value={"true"}>Sim</MenuItem>
            <MenuItem value={"false"}>Não</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <TextField
          type="email"
          label="Email"
          variant="filled"
          fullWidth
          value={form?.email ?? ""}
          onChange={handleChange("email")}
          disabled={params.publicId ? true : false}
        />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <MuiTelInput
          variant="filled"
          fullWidth
          label="Telefone"
          value={form?.telefone ?? ""}
          onChange={handleChange("telefone")}
        />
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <FormControl fullWidth variant="filled">
          <InputLabel id="demo-simple-select-label">Ativo</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={form?.ativo ?? ""}
            label="Ativo"
            fullWidth
            onChange={handleChange("ativo")}
          >
            <MenuItem value={"true"}>Ativo</MenuItem>
            <MenuItem value={"false"}>Inativo</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid xs={6} md={6} lg={6} xl={6}>
        <TextField
          type={showPassword ? "text" : "password"}
          label="Senha"
          variant="filled"
          fullWidth
          value={form?.senha ?? ""}
          onChange={handleChange("senha")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleTogglePasswordVisibility} edge="end">
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid xs={12} md={12} lg={12} xl={12}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button onClick={() => navigate(-1)}>Voltar</Button>
          <ButtonCustom
            text={buttonText}
            event={handleSubmit}
            disabled={!isFormComplete}
          />
        </Stack>
      </Grid>
    </Grid>
  );
}

export default UserRegisterPage;
